import React from 'react';
import PropTypes from 'prop-types';

import TextareaFieldStyled from './TextareaField.styled';
import { handleShowError, handleError } from 'utils';

const TextareaField = ({
  field: { name, value, onChange, onBlur },
  classname,
  form: { errors, touched },
  label,
  required,
  variant,
  fullWidth,
  disabled,
  inputProps,
  rows,
  asyncErrors,
  margin,
  ...props
}) => {
  return (
    <TextareaFieldStyled
      multiline
      minRows={rows}
      name={name}
      label={label}
      value={value}
      margin={margin}
      onBlur={onBlur}
      variant={variant}
      onChange={onChange}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      className={classname}
      InputProps={{id: name, ...inputProps}}
      InputLabelProps={{htmlFor: name}}
      error={handleError(name, errors, touched, asyncErrors)}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      {...props}
    />
  );
};

TextareaField.propTypes = {
  rows: PropTypes.number,
  margin: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  classname: PropTypes.any,
  inputProps: PropTypes.object,
  asyncErrors: PropTypes.string,
  label: PropTypes.string,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

TextareaField.defaultProps = {
  rows: 4,
  inputProps: {},
  required: true,
  fullWidth: true,
  disabled: false,
  margin: 'none',
  variant: 'outlined',
  form: { errors: {}, touched: {} },
};

export default TextareaField;
